import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { PopupService } from '../../../services/popup.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-avatar-input',
  templateUrl: './avatar-input.component.html',
  styleUrls: ['./avatar-input.component.scss'],
})
export class AvatarInputComponent {
  public imgChangeEvt: any = '';
  public tmpFile: any = '';
  public avatar: SafeUrl = '';

  @Input() disabled: boolean = false;
  @Input() public fc: UntypedFormControl | undefined;

  @ViewChild('input') input: ElementRef<HTMLInputElement>;
  @ViewChild('imageCrop') imageCrop: ElementRef;

  constructor(
    public authService: AuthService,
    private popupService: PopupService,
    private sanitizer: DomSanitizer
  ) {}

  onFileChange(event: any): void {
    this.imgChangeEvt = event;
    this.popupService.showPopup(this.imageCrop);
  }

  onAvatarClick(): void {
    if (!this.disabled) {
      this.input.nativeElement.click();
    }
  }

  cropImg(e: ImageCroppedEvent): void {
    this.tmpFile = e.objectUrl ?? '';
  }

  saveCropImg(): void {
    this.avatar = this.sanitizer.bypassSecurityTrustUrl(this.tmpFile);
    this.fc?.setValue(this.avatar);
    this.popupService.closePopup();
  }
}
